module.exports = __webpack_public_path__ + "static/battery-ee6e7a4e09875087857ed9eeb6a9d743.jpg";